import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';

import Radio from '../../../forms/Radio/Radio';
import { Frequency } from '../../../../model/enums';
import ProductPrice from '../../ProductPrice/ProductPrice';
import { $cartState } from '../../../../store/models/cart';

import styles from './styles.module.scss';

type Props = {
  handleSelect: (event: any) => void;
};

const SubscribeCard = ({ handleSelect }: Props) => {
  const { selectedProductSize } = useUnit($cartState);
  const { selectedProduct } = useUnit($cartState);
  const { selectedProductFrequency } = useUnit($cartState);
  const { t } = useTranslation();

  const data = [
    {
      value: Frequency.Weekly,
      cardContent: <div className={styles.freqRadioStyle}>{t("weekly")}</div>,
    },
    {
      value: Frequency.EveryTwoWeeks,
      cardContent: (
        <div className={styles.freqRadioStyle}>
          {t("every2Weeks")}
          <div className={styles.mostPopular}>{t("mostPopular")}</div>
        </div>
      ),
    },
    {
      value: Frequency.EveryThreeWeeks,
      cardContent: <div className={styles.freqRadioStyle}>{t("every3Weeks")}</div>,
    },
    {
      value: Frequency.EveryFourWeeks,
      cardContent: <div className={styles.freqRadioStyle}>{t("every4Weeks")}</div>,
    },
  ];

  const advantagesSVG = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <mask
        id="mask0_18_2033"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_18_2033)">
        <path
          d="M9.55884 15.8897L18.7057 6.74278L19.4016 7.4386L9.55 17.2902L4.59843 12.3386L5.29425 11.6428L9.54116 15.8897L9.55 15.8985L9.55884 15.8897Z"
          fill="#006633"
          stroke="#006633"
          strokeWidth="0.025"
        />
      </g>
    </svg>
  );

  let gridStr = '1fr 1fr 1fr 1fr ';

  return (
    <div className={styles.subscribeCard}>
      <h3>{t("subscribeAndSave")}</h3>
      <ProductPrice
        // @ts-ignore
        currentPrice={selectedProductSize ? selectedProduct?.subscribe_price : 0}
        // @ts-ignore
        prevPrice={selectedProductSize ? selectedProduct?.actual_price : 0}
        isRightPrevPrice
        isGreen
        style={{
          width: 'fit-content',
          fontSize: '20px',
        }}
      />
      <Radio
        data={data}
        handleSelect={handleSelect}
        selectedOption={selectedProductFrequency}
        extraStyle={{
          gridTemplateColumns: gridStr,
        }}
      />
      <div className={styles.advantages}>
        <div className={styles.advantages_item}>
          {advantagesSVG} <p>{t("save5Prc")}</p>
        </div>
        <div className={styles.advantages_item}>
          {advantagesSVG} <p>{t("freeReturnAndRefundPolicy")}</p>
        </div>
        <div className={styles.advantages_item}>
          {advantagesSVG} <p>{t("noCommitmentPauseCancel")}</p>
        </div>
      </div>
    </div>
  );
};

export default SubscribeCard;
